import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-acc',
  templateUrl: './delete-acc.component.html',
  styleUrls: ['./delete-acc.component.scss']
})
export class DeleteAccComponent implements OnInit {
  selectedLang
  constructor(public translate: TranslateService) { 
    this.selectedLang = translate.currentLang;
  }

  ngOnInit(): void {
  }
  selectedValue(value) {
    this.selectedLang = value;
  }
}
